import { HeapCategory, HeapMetadata } from 'clientServerShared/types/eventTracking';
import { Link, Typography } from '@mui/material';

import { CareResourcesArticleLinkFragment } from 'projects/sharedComponents/src/generated/contentful-graphql-types';
import { FC } from 'react';
import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';
import { Link as ReactRouterLink } from 'react-router-dom';
import { getHeapDataAttributes } from 'projects/sharedComponents/src/services/eventTracking/eventTracking';
import { replaceTextPersonalizedVariableContent } from 'projects/sharedComponents/src/pet/careResources/contentful/replacePersonalizedVariableContent';

export type CareResourcesArticleLinkProps = {
  article: CareResourcesArticleLinkFragment;
  reasonId: string;
  pet: PersonalizedVariableContentFragment;
  useReactRouterLink?: boolean;
} & Pick<HeapMetadata, 'heapValue'>;

export const CareResourcesArticleLink: FC<CareResourcesArticleLinkProps> = (props) => {
  const { article, pet, reasonId, useReactRouterLink = true, heapValue } = props;

  const articleLink = `/members/results/care/article/${article.slug}?i=${pet.petNum}&reasonId=${reasonId}`;

  return (
    <Link
      href={articleLink}
      to={articleLink}
      component={useReactRouterLink ? ReactRouterLink : Link}
      className="careResourcesProduct careResourcesArticleLink"
      {...getHeapDataAttributes({
        heapCategory: HeapCategory.CARE_RESOURCES,
        heapAction: 'Click Care Resources Article',
        heapDetails: article.title ?? undefined,
        heapValue,
      })}
    >
      {/* The article image */}
      <div className="careResourcesProduct-imageContainer careResourcesProduct-fullHeightImage">
        <div className="careResourcesProduct-imageBorder">
          {article.image && article.image.url && (
            <img className="careResourcesProduct-image" src={article.image.url} alt="" />
          )}
        </div>
      </div>

      {/* The title of the article */}
      <div className="careResourcesProduct-productInfoContainer">
        <div className="careResourcesProduct-title">
          <Typography variant="body1">
            <b className="careResourcesProduct-productName">
              {replaceTextPersonalizedVariableContent(pet, article.title ?? '')}
            </b>
          </Typography>
        </div>
      </div>
    </Link>
  );
};
